// extracted by mini-css-extract-plugin
export default {"interval":"PeriodToggle_interval__7Ie9i"};